import { FieldGroup } from '../../../general/fields';
import React from 'react';
import { SearchablePeriscopeFieldGroupListV3 } from '@periscopes/general/fields/SearchablePeriscopeFieldGroupListV3';
import { SfFlowNodeGroup } from '@sonar-software/sonar-ts-types';

export interface FlowByNodeTabProps {
	index: number;
	sonarObjectId: number;
}

function mapGroupForFlows(group: SfFlowNodeGroup): FieldGroup {
	return {
		fields: group.fields,
		name: group.name
	};
}

export const FlowByNodeTab: React.FC<FlowByNodeTabProps> = ({ index, sonarObjectId }) => {
	const targetUri = `v3/salesforce/flows/${sonarObjectId}/RefsByNode`;

	return (
		<SearchablePeriscopeFieldGroupListV3
			mapGroup={ mapGroupForFlows }
			parentIndex={ index }
			showParents
			uri={ targetUri }
			useDql />
	);
};
